module.exports = __webpack_public_path__ + "img/client_icon.563976a9.png";